import { provideSvgIcons, provideSvgIconsConfig } from '@ngneat/svg-icon';
import { settingsIcon } from './svg/settings';
import { accountCircleIcon } from './svg/account_circle';
import { allInboxIcon } from './svg/all_inbox';
import { accountCircleBoldIcon } from './svg/account_circle_bold';
import { addIcon } from './svg/add';
import { archiveIcon } from './svg/archive';
import { arrowBackIcon } from './svg/arrow_back';
import { arrowBackIosIcon } from './svg/arrow_back_ios';
import { arrowForwardIcon } from './svg/arrow_forward';
import { attachmentIcon } from './svg/attachment';
import { blockIcon } from './svg/block';
import { book4SparkIcon } from './svg/book_4_spark';
import { bookmarkBorderIcon } from './svg/bookmark_border';
import { bookmarkRemoveIcon } from './svg/bookmark_remove';
import { borderColorIcon } from './svg/border_color';
import { bubbleChartIcon } from './svg/bubble_chart';
import { closeIcon } from './svg/close';
import { databaseIcon } from './svg/database';
import { databaseSearchIcon } from './svg/database_search';
import { deleteHistoryIcon } from './svg/delete_history';
import { deleteIcon } from './svg/delete';
import { descriptionIcon } from './svg/description';
import { draftIcon } from './svg/draft';
import { editIcon } from './svg/edit';
import { eventIcon } from './svg/event';
import { filterListIcon } from './svg/filter_list';
import { groupIcon } from './svg/group';
import { historyIcon } from './svg/history';
import { idCardIcon } from './svg/id_card';
import { infoIcon } from './svg/info';
import { keyIcon } from './svg/key';
import { keyboardDoubleArrowDownIcon } from './svg/keyboard_double_arrow_down';
import { keyboardDoubleArrowUpIcon } from './svg/keyboard_double_arrow_up';
import { kidStarIcon } from './svg/kid_star';
import { kidStarFilledIcon } from './svg/kid_star_filled';
import { localPostOfficeIcon } from './svg/local_post_office';
import { locationOnIcon } from './svg/location_on';
import { mailIcon } from './svg/mail';
import { mapsUgcIcon } from './svg/maps_ugc';
import { markEmailUnreadIcon } from './svg/mark_email_unread';
import { notificationsIcon } from './svg/notifications';
import { openJamIcon } from './svg/open_jam';
import { personIcon } from './svg/person';
import { personOffIcon } from './svg/person_off';
import { refreshIcon } from './svg/refresh';
import { sellIcon } from './svg/sell';
import { shareIcon } from './svg/share';
import { sideNavigationIcon } from './svg/side_navigation';
import { thumbnailBarIcon } from './svg/thumbnail_bar';
import { tuneIcon } from './svg/tune';
import { unarchiveIcon } from './svg/unarchive';
import { workIcon } from './svg/work';
import { imageIcon } from './svg/image';
import { csvIcon } from './svg/csv';
import { textSnippetIcon } from './svg/text_snippet';
import { textAdIcon } from './svg/text_ad';
import { extractionIcon } from './svg/extraction';

export const svgIcons = [
  settingsIcon,
  accountCircleIcon,
  allInboxIcon,
  accountCircleBoldIcon,
  addIcon,
  archiveIcon,
  arrowBackIcon,
  arrowBackIosIcon,
  arrowForwardIcon,
  attachmentIcon,
  blockIcon,
  book4SparkIcon,
  bookmarkBorderIcon,
  bookmarkRemoveIcon,
  borderColorIcon,
  bubbleChartIcon,
  closeIcon,
  databaseIcon,
  databaseSearchIcon,
  deleteHistoryIcon,
  deleteIcon,
  descriptionIcon,
  draftIcon,
  editIcon,
  eventIcon,
  filterListIcon,
  groupIcon,
  historyIcon,
  idCardIcon,
  infoIcon,
  keyIcon,
  keyboardDoubleArrowDownIcon,
  keyboardDoubleArrowUpIcon,
  kidStarIcon,
  kidStarFilledIcon,
  localPostOfficeIcon,
  locationOnIcon,
  mailIcon,
  mapsUgcIcon,
  markEmailUnreadIcon,
  notificationsIcon,
  openJamIcon,
  personIcon,
  personOffIcon,
  refreshIcon,
  sellIcon,
  shareIcon,
  sideNavigationIcon,
  thumbnailBarIcon,
  tuneIcon,
  unarchiveIcon,
  workIcon,
  imageIcon,
  csvIcon,
  textSnippetIcon,
  textAdIcon,
  extractionIcon,
];

export const svgIconProviders = [
  provideSvgIcons(svgIcons),
  provideSvgIconsConfig({
    sizes: {
      xs: '0.875rem',
      sm: '1rem',
      md: '1.125rem',
      lg: '1.25rem',
      xl: '1.375rem',
      '2xl': '1.625rem',
      '3xl': '1.875rem',
      '4xl': '2.125rem',
      '5xl': '2.375rem',
      '6xl': '2.625rem',
      '7xl': '2.875rem',
      '8xl': '3.125rem',
    },
    defaultSize: 'md',
  }),
];
